// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
// index.js

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import V3Gate from './V3Gate';

ReactDOM.render(
  <React.StrictMode>
    <V3Gate>
      <App />
    </V3Gate>
  </React.StrictMode>,
  document.getElementById('root')
);


// If you use reportWebVitals, you can import and use it here
// import reportWebVitals from './reportWebVitals';
// reportWebVitals(console.log);
